/**
 * https://github.com/microsoft/TypeScript/issues/20707#issuecomment-351874491
 */
function notNull<T>(x: T | null): x is T {
  return x !== null
}

export default notNull
